export default __webpack_public_path__ + "static/media/bestLearner.451b1d7b.svg";